module.exports = __webpack_public_path__ + "static/media/volca-simple.38a86a32.gif";